<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="text-center py-3" v-if="employeesLoading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>

      <v-col cols="12" v-if="!employeesLoading && employees.length > 0">
        <v-simple-table :headers="headers" :items="employees">
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.text">
                  {{header.text}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item, index in employees"
                :key="index"
              >
                <td>
                  <v-simple-checkbox color="primary" v-ripple @click.prevent="updateEmployeeMetaEnabled(item.employeeMeta.id, item.employeeMeta.groupTextEnabled, index)" :value="item.employeeMeta.groupTextEnabled"></v-simple-checkbox>
                </td>
                <td>{{item.user.attributes.full_name}}</td>
                <td>{{item.user.attributes.phone_number}}</td>
                <td>
                  <v-simple-checkbox color="primary" v-ripple @click.prevent="updateEmployeeMetaCostaMesa(item.employeeMeta.id, !item.employeeMeta.locationCostaMesa, index)" :value="item.employeeMeta.locationCostaMesa"></v-simple-checkbox>
                </td>
                <td>
                  <v-simple-checkbox color="primary" v-ripple @click.prevent="updateEmployeeMetaLongBeach(item.employeeMeta.id, !item.employeeMeta.locationLongBeach, index)" :value="item.employeeMeta.locationLongBeach"></v-simple-checkbox>
                </td>
                <td>
                  <v-simple-checkbox color="primary" v-ripple @click.prevent="updateEmployeeMetaNewportBeach(item.employeeMeta.id, !item.employeeMeta.locationNewportBeach, index)" :value="item.employeeMeta.locationNewportBeach"></v-simple-checkbox>
                </td>
                <td>
                  <v-simple-checkbox color="primary" v-ripple @click.prevent="updateEmployeeMetaMissionViejo(item.employeeMeta.id, !item.employeeMeta.locationMissionViejo, index)" :value="item.employeeMeta.locationMissionViejo"></v-simple-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
// import find from 'lodash/find'

export default {
  name: 'StudioManagerTable',

  data() {
    return {
      headers: [
        {
          text: 'Enabled',
          value: 'employeeMeta.groupTextEnabled',
        },
        {
          text: 'Name',
          value: 'user.attributes.full_name',
        },
        {
          text: 'Phone',
          value: 'user.attributes.phone_number'
        },
        {
          text: 'Costa Mesa',
          value: 'employeeMeta.locationCostaMesa',
        },
        {
          text: 'Long Beach',
          value: 'employeeMeta.locationLongBeach',
        },
        {
          text: 'Newport Beach',
          value: 'employeeMeta.locationNewportBeach',
        },
        {
          text: 'Mission Viejo',
          value: 'employeeMeta.locationMissionViejo',
        },
      ]
    }
  },

  computed: {
    ...mapGetters({
      employees: 'employee/list',
    }),
    employeesLoading() {
      return this.$store.state['employee'].isFindPending
    },
  },

  methods: {
    async updateEmployeeMetaNaughty(id, value, index) {
      this.employees[index].employeeMeta.isNaughtyList = !value
      this.$store.dispatch('employee-meta/patch', [id, { isNaughtyList: !value }, {}])
    },
    async updateEmployeeMetaEnabled(id, value, index) {
      this.employees[index].employeeMeta.groupTextEnabled = !value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextEnabled: !value }, {}])
    },
    async updateEmployeeMetaHotRa(id, value, index) {
      this.employees[index].employeeMeta.groupTextHotRa = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextHotRa: value }, {}])
    },
    async updateEmployeeMetaVinyasa(id, value, index) {
      this.employees[index].employeeMeta.groupTextVinyasa = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextVinyasa: value }, {}])
    },
    async updateEmployeeMetaYogalates(id, value, index) {
      this.employees[index].employeeMeta.groupTextYogalates = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextYogalates: value }, {}])
    },
    async updateEmployeeMetaStrength(id, value, index) {
      this.employees[index].employeeMeta.groupTextStrength = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextStrength: value }, {}])
    },
    async updateEmployeeMetaPrenatal(id, value, index) {
      this.employees[index].employeeMeta.groupTextPrenatal = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextPrenatal: value }, {}])
    },
    async updateEmployeeMetaYin(id, value, index) {
      this.employees[index].employeeMeta.groupTextYin = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextYin: value }, {}])
    },
    async updateEmployeeMetaBaby(id, value, index) {
      this.employees[index].employeeMeta.groupTextBaby = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextBaby: value }, {}])
    },
    async updateEmployeeMetaMeditation(id, value, index) {
      this.employees[index].employeeMeta.groupTextMeditation = value
      this.$store.dispatch('employee-meta/patch', [id, { groupTextMeditation: value }, {}])
    },
    async updateEmployeeMetaCostaMesa(id, value, index) {
      this.employees[index].employeeMeta.locationCostaMesa = value
      this.$store.dispatch('employee-meta/patch', [id, { locationCostaMesa: value }, {}])
    },
    async updateEmployeeMetaLongBeach(id, value, index) {
      this.employees[index].employeeMeta.locationLongBeach = value
      this.$store.dispatch('employee-meta/patch', [id, { locationLongBeach: value }, {}])
    },
    async updateEmployeeMetaNewportBeach(id, value, index) {
      this.employees[index].employeeMeta.locationNewportBeach = value
      this.$store.dispatch('employee-meta/patch', [id, { locationNewportBeach: value }, {}])
    },
    async updateEmployeeMetaMissionViejo(id, value, index) {
      this.employees[index].employeeMeta.locationMissionViejo = value
      this.$store.dispatch('employee-meta/patch', [id, { locationMissionViejo: value }, {}])
    },
  },

  async beforeMount() {
    await this.$store.commit('employee/clearAll', this.$store.state['employee'])
    await this.$store.dispatch('employee/find', {
      query: {
        limit: 300,
        include: 'user,public_profile',
        is_active: true,
        group: 'Studio Manager'
      }
    })
  }
}
</script>

<style lang="scss">

</style>